import { render, staticRenderFns } from "./PartnerNav.vue?vue&type=template&id=0b50a651&scoped=true&"
import script from "./PartnerNav.vue?vue&type=script&lang=js&"
export * from "./PartnerNav.vue?vue&type=script&lang=js&"
import style0 from "./PartnerNav.vue?vue&type=style&index=0&id=0b50a651&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b50a651",
  null
  
)

export default component.exports